/* eslint-disable react/display-name */
import { MarkType, NodeType } from '@contentstack/utils';
import { fm } from 'src/api/graphql/translation';
import ContentLink from 'src/components/contentstack/content-link';
import { Iframe } from 'src/components/groceries';
import { learnHost, replaceDomainUrl } from 'src/env';
import Script from './Script';
const anchor = (id) => (
  <span
    id={id}
    style={{
      visibility: 'hidden',
      display: 'block',
      position: 'relative',
      top: '-100px',
    }}
  ></span>
);

class MenusInfo {
  menusList;
  topMenuCount;
  secondaryCount;

  constructor() {
    this.init();
  }

  init() {
    this.menusList = [];
    this.topMenuCount = 1;
    this.secondaryCount = 1;
  }

  // h2 h3
  createTopMenu(item) {
    const id = this.topMenuCount;
    this.menusList.push({
      id: this.topMenuCount,
      name: item.name,
      children: [],
    });
    this.topMenuCount += 1;
    this.secondaryCount = 1;
    return id;
  }

  createSecondary(item) {
    if (this.menusList.length === 0) return;
    const cur = this.menusList[this.menusList.length - 1];
    const id = `${cur.id}-${this.secondaryCount}`;
    if (cur) {
      cur.children.push({
        id,
        name: item.name,
      });
    }
    this.secondaryCount += 1;
    return id;
  }
}

export const menusInfo = new MenusInfo();

// export const { menusList } = menusInfo;

export const renderOption = {
  span: (node, next) => {
    return (
      <span style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </span>
    );
  },
  div: (node, next) => {
    return (
      <div style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </div>
    );
  },
  a: (node, next) => {
    let rel = 'noreferrer nofollow';
    if (node?.attrs?.url?.indexOf(learnHost) > -1) {
      rel = 'noreferrer';
    }
    return (
      // eslint-disable-next-line react/jsx-no-target-blank
      <a
        style={node.attrs['style']}
        href={replaceDomainUrl(node.attrs?.url)}
        target="_blank"
        rel={rel}
        key={node.uid}
      >
        {next(node.children)}
      </a>
    );
  },
  'error-block': (node, next) => {
    return (
      <p style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </p>
    );
  },
  'social-embeds': (node, next) => {
    const TWITTER_CLASS = {
      name: 'twitter-widget',
      reg: /twitter/,
    };
    const YOUTUBE_CLASS = {
      name: 'youtube-widget',
      reg: /youtube/,
    };
    let className = '';
    if (TWITTER_CLASS.reg.test(node.attrs?.src)) {
      className = TWITTER_CLASS.name;
    }
    if (YOUTUBE_CLASS.reg.test(node.attrs?.src)) {
      className = YOUTUBE_CLASS.name;
    }
    return (
      <iframe className={className} id={node.uid} src={node.attrs?.src}>
        {next(node.children)}
      </iframe>
    );
  },
  block: {
    entity_component: (item) => {
      const { alignment = '' } = item;
      switch (item.type) {
        case 'code':
          return (
            <>
              <span dangerouslySetInnerHTML={{ __html: item.html }}></span>
              <Script code={item.code} />
            </>
          );

        case 'disclaimer':
          const text = item.display_text;
          const local = item.system?.locale;
          return (
            text && (
              <div
                style={{
                  background: 'rgba(224, 64, 64, 0.08)',
                  'border-radius': '16px',
                  padding: '32px',
                }}
              >
                <span
                  style={{
                    color: '#a10808',
                    'font-weight': 'bold',
                  }}
                >
                  *{fm('post.postDetail.disclaimer', '', local)}:{' '}
                </span>
                <span>{text}</span>
              </div>
            )
          );

        case 'button':
        default:
          let rel = 'noreferrer nofollow';
          if (item?.attrs?.url?.indexOf(learnHost) > -1) {
            rel = 'noreferrer';
          }

          return (
            <div style={{ textAlign: alignment }}>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a href={replaceDomainUrl(item?.url)} target="_blank" rel={rel}>
                <button id={item.uid}>{item.display_text}</button>
              </a>
            </div>
          );
      }
    },
    $default: (item, metadata) => {
      return ``;
    },
  },
  inline: {
    entity_component: (item, metadata) => {
      switch (item.type) {
        case 'code':
          return (
            <>
              <span dangerouslySetInnerHTML={{ __html: item.html }}></span>
              <Script code={item.code} />
            </>
          );
        case 'button':
        default:
          return (
            <a
              href={replaceDomainUrl(item.url)}
              target="_blank"
              rel="noreferrer nofollow"
            >
              <button id={item.uid}>{item.display_text}</button>
            </a>
          );
      }
    },
    $default: (item, metadata) => {
      return ``;
    },
  },
  embed: (node, next) => {
    return <Iframe node={node} next={next} />;
  },
  link: (item, metadata) => {
    let rel = 'noreferrer nofollow';
    if (item?.attrs?.url?.indexOf(learnHost) > -1) {
      rel = 'noreferrer';
    }
    return (
      // eslint-disable-next-line react/jsx-no-target-blank
      <a
        href={replaceDomainUrl(metadata.attributes.href)}
        key={item.uid}
        target="_blank"
        rel={rel}
      >
        {metadata.text}
      </a>
    );
  },
  img: (item, next) => {
    if (item?.attrs?.anchorLink) {
      let rel = 'noreferrer nofollow';
      if (item?.attrs?.url?.indexOf(learnHost) > -1) {
        rel = 'noreferrer';
      }
      return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a
          key={item.uid}
          href={replaceDomainUrl(item?.attrs?.anchorLink)}
          target="_blank"
          rel={rel}
        >
          <img
            width={`${item.attrs.width}%`}
            src={item.attrs.url}
            alt={item.attrs?.title}
            key={item.uid}
          />
        </a>
      );
    }

    return (
      <img
        width={`${item.attrs.width}%`}
        src={item.attrs.url}
        alt={item.attrs?.title}
        key={item.uid}
      />
    );
  },
  display: (item, metadata) => {
    const inline = metadata.attributes['inline'] ?? false;
    return inline ? (
      <ContentLink
        key={item.uid}
        href={metadata.attributes['link']}
        target={metadata.attributes['target']}
      >
        <img
          className={metadata.attributes['class-name']}
          style={metadata.attributes['style']}
          width={metadata.attributes['width']}
          height={metadata.attributes['height']}
          src={metadata.attributes['asset-link']}
          alt={metadata.attributes['asset-alt']}
          key={`${item.uid}-img`}
        />
      </ContentLink>
    ) : (
      <ContentLink
        key={item.uid}
        href={metadata.attributes['link']}
        target={metadata.attributes['target']}
      >
        <div
          key={`${item.uid}-div`}
          style={metadata.attributes['style']}
          className={metadata.attributes['class-name']}
        >
          <img
            width={metadata.attributes['width']}
            height={metadata.attributes['height']}
            src={metadata.attributes['asset-link']}
            alt={metadata.attributes['asset-alt']}
            key={item.uid}
          />
          {metadata.attributes['asset-caption'] ? (
            <p className="subtitle">{metadata.attributes['asset-caption']}</p>
          ) : null}
        </div>
      </ContentLink>
    );
  },
  [NodeType.DOCUMENT]: (node) => {
    return ``;
  },
  // [NodeType.LINK]: (node, next) => {
  //   return `<a href="${node.attrs.href}">${next(node.children)}</a>`;
  // },
  // [NodeType.IMAGE]: (node, next) => {
  //   return `<img src="${node.attrs.src}" />${next(node.children)}`;
  // },
  // [NodeType.EMBED]: (node, next) => {
  // return `<iframe src="${node.attrs.src}">${next(node.children)}</iframe>`;
  // },
  [NodeType.HEADING_1]: (node, next) => {
    return (
      <h1 style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </h1>
    );
  },
  [NodeType.HEADING_2]: (node, next) => {
    const id = menusInfo.createTopMenu({ name: node.children[0]?.text });
    return (
      <h2 style={node.attrs['style']} key={node.uid}>
        {anchor(id)}
        {next(node.children)}
      </h2>
    );
  },
  [NodeType.HEADING_3]: (node, next) => {
    const id = menusInfo.createSecondary({ name: node.children[0]?.text });
    return (
      <h3 style={node.attrs['style']} key={node.uid}>
        {anchor(id)}
        {next(node.children)}
      </h3>
    );
  },
  [NodeType.HEADING_4]: (node, next) => {
    return (
      <h4 style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </h4>
    );
  },
  [NodeType.HEADING_5]: (node, next) => {
    return (
      <h5 style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </h5>
    );
  },
  [NodeType.HEADING_6]: (node, next) => {
    return (
      <h6 style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </h6>
    );
  },
  [NodeType.PARAGRAPH]: (node, next) => {
    return (
      <p style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </p>
    );
  },
  [NodeType.ORDER_LIST]: (node, next) => {
    return (
      <ol style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </ol>
    );
  },
  [NodeType.UNORDER_LIST]: (node, next) => {
    return (
      <ul style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </ul>
    );
  },
  [NodeType.LIST_ITEM]: (node, next) => {
    return (
      <li style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </li>
    );
  },
  [NodeType.HR]: (node, next) => {
    return <hr key={node.uid}></hr>;
  },
  [NodeType.TABLE]: (node, next) => {
    return (
      <div key={node.uid} className="table-wrapper">
        <table>{next(node.children)}</table>
      </div>
    );
  },
  [NodeType.TABLE_HEADER]: (node, next) => {
    return <thead key={node.uid}>{next(node.children)}</thead>;
  },
  [NodeType.TABLE_BODY]: (node, next) => {
    return <tbody key={node.uid}>{next(node.children)}</tbody>;
  },
  [NodeType.TABLE_FOOTER]: (node, next) => {
    return <tfoot key={node.uid}>{next(node.children)}</tfoot>;
  },
  [NodeType.TABLE_ROW]: (node, next) => {
    return (
      <tr style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </tr>
    );
  },
  [NodeType.TABLE_HEAD]: (node, next) => {
    return (
      <th style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </th>
    );
  },
  [NodeType.TABLE_DATA]: (node, next) => {
    return (
      <td style={node.attrs['style']} key={node.uid}>
        {next(node.children)}
      </td>
    );
  },
  [NodeType.BLOCK_QUOTE]: (node, next) => {
    return <blockquote key={node.uid}>{next(node.children)}</blockquote>;
  },
  [NodeType.CODE]: (node, next) => {
    return <code key={node.uid}>{next(node.children)}</code>;
  },
  ['reference']: (node, next) => {
    return ``;
  },
  [MarkType.BOLD]: (text) => {
    return <strong key={text}>{text}</strong>;
  },
  [MarkType.ITALIC]: (text) => {
    return <em key={text}>{text}</em>;
  },
  [MarkType.UNDERLINE]: (text) => {
    return <u key={text}>{text}</u>;
  },
  [MarkType.STRIKE_THROUGH]: (text) => {
    return <strike key={text}>{text}</strike>;
  },
  [MarkType.INLINE_CODE]: (text) => {
    return <span key={text}>{text}</span>;
  },
  [MarkType.SUBSCRIPT]: (text) => {
    return <sub key={text}>{text}</sub>;
  },
  [MarkType.SUPERSCRIPT]: (text) => {
    return <sup key={text}>{text}</sup>;
  },
  fragment: (node, next) => {
    return <>{next(node.children)}</>;
  },
};
